<template>
  <div class="microStation">
    <div class="microTop">微站</div>
    <div class="microText">
      <div class="microLeft">
        <img src="~@/assets/img/microStation.png" alt />
      </div>
      <div class="microRig">
        <el-input placeholder="请输入查询"></el-input>
        <div class="cxun"><img src="~@/assets/img/cxun.png" alt=""></div>
      </div>
    </div>
    <div class="microTab">
      <el-table :data="tableData" stripe style="width: 842px;margin:auto;border: 1px solid #FFFFFF;border-radius: 10px;   background: transparent;">
        <el-table-column  type="selection" width="50"></el-table-column>
        <el-table-column  label="部门编码" width="280"></el-table-column>
        <el-table-column  label="部门名称" width="280"></el-table-column>
        <el-table-column  label="街巷"></el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
export default {
    data(){
        return{
            tableData:[]
        }
    }
}
</script>
<style lang="less">

</style>
<style lang="less">
.microStation {
  .microTop {
    text-align: center;
    font-size: 24px;
    font-family: Source Han Sans CN;
    font-weight: 800;
    color: #ffffff;
    line-height: 30px;
    text-shadow: 1px 2px 10px rgba(4, 0, 0, 0.7);
  }
 
  .microText {
    overflow: hidden;
    margin:32px 0 41px 0;
    .microLeft {
      float: left;
    }
    .microRig {
      float: right;
      position: relative;
      line-height: 52px;
      height: 52px;
    
    }
    .el-input__inner{
        width: 358px;
        height: 52px;
        line-height: 52px;
        border-radius: 27px;
    }
    .cxun{
        position:absolute;
        top:-6px;
        right:-6px;
    }
  }

}
</style>


// WEBPACK FOOTER //
// src/components/microStation.vue